export const COUNTRY_CODES = [
  { code: '+91', flag: '🇮🇳', name: 'India', len: 10 },
  { code: '+1', flag: '🇺🇸', name: 'USA', len: 10 },
  { code: '+44', flag: '🇬🇧', name: 'UK', len: 10 },
  { code: '+971', flag: '🇦🇪', name: 'UAE', len: 9 },
  { code: '+61', flag: '🇦🇺', name: 'Australia', len: 9 },
  { code: '+81', flag: '🇯🇵', name: 'Japan', len: 10 },
  { code: '+49', flag: '🇩🇪', name: 'Germany', len: 11 },
  { code: '+33', flag: '🇫🇷', name: 'France', len: 9 },
];

export const DEFAULT_SOURCES = ['Swiggy/Zomato', 'Ola/Uber', 'Fiverr/Upwork', 'Freelance Client', 'Other'];
export const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#6366F1', '#EC4899'];
export const AVATAR_COLORS = ['#EF4444', '#F59E0B', '#10B981', '#3B82F6', '#6366F1', '#8B5CF6', '#EC4899'];
